import { styled } from 'styled-components'

export const ControlButton = styled.button.attrs({ className: 'btn text-white text-uppercase fw-bold p-3 mt-3' })`
  font-size: 2rem;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  aspect-ratio: 1;
  height: max-content;
  border-radius: 50%;
`
